import { useEffect } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import ContactHero from "./components/ContactHero";
import ContactInfoCards from "./components/ContactInfoCards";
import ContactIntro from "./components/ContactIntro";
import ContactMainLayout from "./components/ContactMainLayout";
import WhatsAppSection from "./components/WhatsAppSection";

export default function ContactPage() {
  useEffect(() => {
    document.title =
      "Contact Urban Infra | Villa Plots Enquiry Karnataka | UrbanInfraProjects.in";

    const setMeta = (name: string, content: string, prop = false) => {
      const selector = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let el = document.querySelector(selector) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        if (prop) el.setAttribute("property", name);
        else el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta(
      "description",
      "Contact Urban Infra for villa plot and gated community layout enquiries across Karnataka. Call +91 99451 24133, WhatsApp us, or visit UrbanInfraProjects.in. Mon–Sat 11 AM – 7 PM."
    );
    setMeta("keywords", "contact Urban Infra, villa plots enquiry Karnataka, gated community plots contact, UrbanInfraProjects.in");
    setMeta("og:title", "Contact Urban Infra | Villa Plots Enquiry Karnataka", true);
    setMeta("og:description", "Reach Urban Infra for villa plot enquiries across Karnataka. Call or WhatsApp +91 99451 24133. Visit UrbanInfraProjects.in.", true);
    setMeta("og:url", `${import.meta.env.VITE_SITE_URL ?? "https://www.urbaninfraprojects.in"}/contact`, true);
    setMeta("og:site_name", "Urban Infra", true);
    setMeta("og:type", "website", true);

    // Schema.org JSON-LD — LocalBusiness
    const schemaId = "schema-contact";
    let script = document.getElementById(schemaId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = schemaId;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://www.urbaninfraprojects.in";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "Urban Infra",
      url: siteUrl,
      telephone: "+919945124133",
      email: "sales@urbaninfraproject.in",
      address: {
        "@type": "PostalAddress",
        streetAddress: "#2, CNR Complex, First Floor, Muthanallur Cross, Sarjapur Main Road",
        addressLocality: "Bangalore",
        addressRegion: "Karnataka",
        postalCode: "562125",
        addressCountry: "IN",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: 12.8698,
        longitude: 77.7499,
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          opens: "11:00",
          closes: "19:00",
        },
      ],
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+919945124133",
        contactType: "sales",
        areaServed: "IN",
        availableLanguage: ["English", "Kannada", "Hindi"],
      },
    });

    window.scrollTo(0, 0);
    return () => {
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SiteHeader />
      <main>
        <ContactHero />
        <ContactIntro />
        <ContactInfoCards />
        <ContactMainLayout />
        <WhatsAppSection />
      </main>
      <SiteFooter />
    </div>
  );
}
